import(/* webpackMode: "eager" */ "/codebuild/output/src1495867874/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
